// Hero video: source is attached here rather than in the markup so mobile
// never downloads the file. Loads once the viewport is desktop (>= 960px).
$('.block-hero .hero-video-embed[data-src]').each(function () {
	const video = this;
	const desktop = window.matchMedia('(min-width: 960px)');

	function loadVideo() {
		if (!video.src) {
			video.src = video.dataset.src;
			video.addEventListener('canplay', function () {
				video.classList.add('is-loaded');
			}, { once: true });
		}
	}

	if (desktop.matches) {
		loadVideo();
	} else if (desktop.addEventListener) {
		desktop.addEventListener('change', function (e) {
			if (e.matches) loadVideo();
		});
	}
});

$('.block-hero .js-video-controls').on('click', function () {
	const video = $(this).closest('.block-hero').find('.hero-video-embed')[0];
	if (video.paused) {
		video.play();
		$(this).addClass('is-playing');
	} else {
		video.pause();
		$(this).removeClass('is-playing');
	}
});
